import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import idx from 'idx';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { setStage, toggleConfirmVote, STAGE_DONE } from 'focus_groups/ducks/vote';

export function mapStateToProps(state, { params }) {
  const isConfirmingVote = idx(state, _ => _.project.focusGroups.vote.isConfirmingVote);
  const group = idx(state, _ => _.project.focusGroups.viewState.currentGroup);
  const unvotedRevisions = group.revisions.filter(r => (
    !Object.keys(r.votes).includes(params.participantId)
  )).length;

  let header = 'Are you sure you want to submit your votes?';
  let message = "If you want to make changes to your votes, just click on 'Cancel' below.";
  if (unvotedRevisions > 0) {
    header = "You haven't voted on all entries.";
    message = `Are you sure you want to submit your votes? You have ${unvotedRevisions} un-rated entries.`;
  }

  return {
    dialogVisible: !!isConfirmingVote,
    dialogHeader: header,
    dialogMessage: message,
    primaryActionText: 'Yes, submit votes',
    secondaryActionText: 'Cancel'
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleDialog: toggleConfirmVote,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog));



// WEBPACK FOOTER //
// ./focus_groups/containers/confirm_vote_modal.js